import type { StatusOption } from '../../types';

export const STATUS_OPTIONS: StatusOption[] = [
  { text: 'REQUESTED', key: 'requested', value: 'requested' },
  { text: 'IN-PROGRESS', key: 'in-progress', value: 'in-progress' },
  { text: 'COMPLETED', key: 'completed', value: 'completed' },
  { text: 'FAILED', key: 'failed', value: 'failed' },
  { text: 'CANCELLED', key: 'cancelled', value: 'cancelled' },
  { text: 'ON-HOLD', key: 'paused', value: 'on-hold' },
  { text: 'OUTREACH', key: 'outreach', value: 'received' },
];
